import React from "react";
import { Badge } from "@/components/ui/badge";
import { Clock, CheckCircle2, XCircle, Ban } from "lucide-react";

// Status pill for an employee profile change request. Shared so the employee's
// own list and the admin approval queue can never drift apart on wording or
// colour.
const STATUS_STYLES = {
  pending: {
    label: "Pending",
    icon: Clock,
    className:
      "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-900/30 dark:text-amber-400",
  },
  approved: {
    label: "Approved",
    icon: CheckCircle2,
    className:
      "bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-400",
  },
  rejected: {
    label: "Rejected",
    icon: XCircle,
    className:
      "bg-red-100 text-red-800 border-red-200 dark:bg-red-900/30 dark:text-red-400",
  },
  cancelled: {
    label: "Cancelled",
    icon: Ban,
    className:
      "bg-gray-100 text-gray-700 border-gray-200 dark:bg-gray-800 dark:text-gray-400",
  },
};

export const ChangeRequestStatusBadge = ({ status }) => {
  const style = STATUS_STYLES[status] || STATUS_STYLES.cancelled;
  const Icon = style.icon;

  return (
    <Badge
      variant="outline"
      className={`${style.className} flex items-center gap-1`}
    >
      <Icon className="w-3 h-3" />
      {style.label}
    </Badge>
  );
};

// Requests are timestamped server-side; show the local date and time, since
// "when was this raised" is part of what the admin reviews.
export const formatRequestDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export default ChangeRequestStatusBadge;
